/************************* Lib Files ************************/
import Api from '../../../lib/api';

export const SDG_MAP_DATA = {
	start: 'fetch_start/sdg_map_data',
	end: 'fetch_end/sdg_map_data',
	success: 'fetch_success/sdg_map_data',
	failed: 'fetch_failed/sdg_map_data'
};

export const mapDataFetchStart = () => ({
	type: SDG_MAP_DATA.start
});

export const mapDataFetchEnd = () => ({
	type: SDG_MAP_DATA.end
});

export const mapDataFetchSuccess = (data) => (
	{
		type: SDG_MAP_DATA.success,
		data
	});

export const mapDataFetchFailed = (error) => ({
	type: SDG_MAP_DATA.failed,
	error
});

let mapResponseParser = (dispatch, resp) => {
	if (resp.success && resp.data) {
		let data = resp.data.filter((item, index) => item.latitude !== null && item.longitude !== null);
		data = data.map((item, index) => {
			let outputs = item.outputs.filter((output, key) => output.output_latitude !== null && output.output_longitude !== null);
			item.outputs = outputs;
			return item;
		});
		dispatch(mapDataFetchEnd());
		dispatch(mapDataFetchSuccess(data));
	}
	else {
		dispatch(mapDataFetchEnd());
	}
};

export const loadSdgMapData = (year, sdg, unit, source, tab) => (dispatch) => {
	dispatch(mapDataFetchStart());
	unit = unit?unit:'';
	source = source?source:'';
	sdg = sdg?sdg:'';
	tab = tab?tab:'';

	if (year !== null)
		return Api.get(Api.API_MAP_SDG(year, sdg, unit, source, tab) ).then((resp) => {
			mapResponseParser(dispatch, resp);
		})
			.catch((exception) => {
				dispatch(mapDataFetchEnd());
				dispatch(mapDataFetchFailed(exception));
			});
};


export const loadTargetMapData = (year, target, unit, source, tab) => (dispatch) => {
	dispatch(mapDataFetchStart());
	unit = unit?unit:'';
	source = source?source:'';
	target = target?target:'';
	tab = tab?tab:'';

	if (year !== null)
		return Api.get(Api.API_MAP_SDG_TARGETS(year, target, unit, source, tab) ).then((resp) => {
			mapResponseParser(dispatch, resp);
		})
			.catch((exception) => {
				dispatch(mapDataFetchEnd());
				dispatch(mapDataFetchFailed(exception));
			});
};


// WEBPACK FOOTER //
// ./shared/actions/mapActions/sdgMapData.js